import * as React from "react";
import { forwardRef } from "react";
const SvgL4C = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#fff" viewBox="0 0 23 18" ref={ref} {...props}><rect width={22} height={6} x={0.5} y={11.5} stroke="#4A4A4A" rx={0.5} /><rect width={22} height={8} x={0.5} y={0.5} stroke="#4A4A4A" rx={0.5} /><path stroke="#4A4A4A" d="M0 4.5h21.954" /></svg>;
const ForwardRef = forwardRef(SvgL4C);
export default ForwardRef;